import { initMockCollections } from './db';
import { getMockWorkspace } from './db/workspace';
import { initMockDiscoverySessions } from './handlers/discovery-handlers';

export async function initMSW() {
  const shouldEnableMSW =
    import.meta.env.VITE_ENABLE_MSW === 'true' || import.meta.env.VITE_ENVIRONMENT === 'local';

  // 로컬 디자인/프로토타입 작업에서는 기본적으로 mock을 활성화합니다.
  if (!shouldEnableMSW) {
    return;
  }

  const { worker } = await import('./browser');
  // collection (db) clearing 및 기본 dummy 데이터 셋업
  await initMockCollections();
  initMockDiscoverySessions([getMockWorkspace().id]);

  return worker.start({
    onUnhandledRequest: 'bypass', // 등록되지 않은 요청은 실제 서버로 통과
  });
}
